import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import logo from "../Dutch-Tech-Inc.jpg";
const api = process.env.REACT_APP_API_URL;

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(`${api}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: credentials.username,
          password: credentials.password,
        }),
      });

      if (!response.ok) {
        throw new Error("Login failed");
      }

      const data = await response.json();
      login(data.access_token);
      // Resume the last page this browser was on (overview by default).
      navigate("/", { replace: true });
    } catch (err) {
      setError("Invalid username or password.");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: { xs: 2, sm: 3 },
        py: { xs: 4, sm: 6 },
      }}
    >
      <Container maxWidth="xs" disableGutters>
        <Card
          sx={{
            width: "100%",
            p: { xs: 1, sm: 2 },
            boxShadow: 3,
            borderRadius: { xs: 2, sm: 3 },
          }}
        >
          <CardMedia
            component="img"
            image={logo}
            alt="Logo"
            sx={{
              height: { xs: 64, sm: 80 },
              objectFit: "contain",
              mx: "auto",
              mt: { xs: 1.5, sm: 2 },
            }}
          />
          <CardContent sx={{ px: { xs: 2, sm: 3 } }}>
            <Typography
              variant="h5"
              align="center"
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              Login
            </Typography>
            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                size="medium"
                label="Username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                margin="normal"
                autoComplete="username"
                inputMode="email"
              />
              <TextField
                fullWidth
                size="medium"
                type="password"
                label="Password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                margin="normal"
                autoComplete="current-password"
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                sx={{ mt: 2.5, py: 1.25, fontWeight: 600 }}
              >
                Login
              </Button>
            </form>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
